export const ERR_DEFAULT = 'default';
export const FORBIDDEN_ERROR_CODE = 403;
export const INTERNAL_SERVER_ERROR = 500;
export const EXTERNAL_AUTH_TOKEN_NOT_FOUND = 'EXTERNAL_AUTH_TOKEN_NOT_FOUND';
